import { createGlobalStyle } from 'styled-components';
import { isInIframe } from '~/iframeMode';

export const navbarDividerThickness = 2; // px
export const navbarHeight = 60; // px

const GlobalStyle = createGlobalStyle`
  :root {
    --navbar-height: ${navbarHeight}px;
  }

@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
  html {
    overflow-x: hidden;
    overflow-y: ${isInIframe ? 'hidden' : 'initial'};
    width: 100%;
    height: ${isInIframe ? 'auto' : '100%'};
  }

  body {
    font-family: 'Poppins', sans-serif;
    width: 100%;
    height: ${isInIframe ? 'auto' : '100%'};
    background-color: ${isInIframe ? 'transparent !important' : '#fff'};
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    overflow-x: hidden;
    overflow-y: ${isInIframe ? 'hidden' : 'initial'};
  }

  #root {
    height: ${isInIframe ? 'auto' : '100%'};
  }

  /* Styling ::-webkit-scrollbar opts out of the OS auto-hiding overlay
     scrollbar, keeping scrollbars visible whenever content overflows.
     The thumb mimics the native macOS one: translucent, rounded, inset
     in a transparent gutter */
  ::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 9999px;
    border: 4px solid transparent;
    background-clip: padding-box;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  /* Firefox only: in Chromium/Safari these standard properties would
     override ::-webkit-scrollbar and reintroduce the auto-hiding
     overlay scrollbar on macOS */
  @supports not selector(::-webkit-scrollbar) {
    * {
      scrollbar-color: rgba(0, 0, 0, 0.4) transparent;
    }
  }
  
  .verification-character {
    border: none;
    font-size: 16px;
    border-radius: 2px;
    padding-top: 17.5px;
    background-color: #F1F3F3;
    outline: none;
  }

  .verification-character--error {
    border: none;
    font-size: 16px;
    border-radius: 2px;
    padding-top: 17.5px;
    background-color: #FAE6E6;
    outline: none;
  }

  .verification-character--selected {
    position: relative;
    background-color: #E6EAEA;
    color: #1C1C1C;
  }

  .verification-character--selected--error {
    position: relative;
    background-color: #E5D0D0;
    color: #1C1C1C;
  }
   
  .verification-character--selected:empty::after {
    content: "";
    width: 1px;
    height: 30px;
    background-color: #1C1C1C;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: blink 1s infinite step-end;
  }

  .verification-character--selected--error:empty::after {
    content: "";
    width: 1px;
    height: 30px;
    background-color: #1C1C1C;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: blink 1s infinite step-end;
  }
   
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }

  .vi__wrapper {
    max-width: 100%;
}
  .vi__container {
    max-width: 100%;
  }
`;

export default GlobalStyle;
